/// <reference path="confirmationmanager.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ConfirmationManager {

    interface SortSetting {
        label: string,
        fieldOrderBy: string,
        sortDirection: Model.SortDirection
    }

    interface CommunicationFilter {
        label: string,
        type:  Meevo.Model.CommunicationMethodEnum,
    }

    interface StatusFilter {
        type: Meevo.Model.ConfirmStateFilterEnum,
        confirmCode?: Meevo.Model.AppointConfirmStateEnum,
    };

    class ConfirmationManagerController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        private items;
        private client;
        private clientAppointments;
        private filter;
        private displayDetails;
        private dateFilter = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        public clientFilter = { id: null };
        public employeeFilter = { id: null };
        public unconfirmedClientCount: number;
        public unableToContactCount: number;
        public waitingOnReplyClientCount: number;
        public confirmedClientCount: number;
        public respondedRescheduleClientCount: number;
        public unableToContactClientCount: number;
        public allClientCount: number;
        public isMobile: boolean;

        public meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        private sortDirection = Model.SortDirection.Ascending;
        private fieldOrderBy = 'StartDateTime';
        public confirmationStatusControl: any = {};

        private sortBySettings: SortSetting[] = [
            {
                label: 'LABEL_CLIENT_ASCENDING',
                fieldOrderBy: 'LastName',
                sortDirection: Model.SortDirection.Ascending
            },
            {
                label: 'LABEL_CLIENT_DESCENDING',
                fieldOrderBy: 'LastName',
                sortDirection: Model.SortDirection.Descending
            },
            {
                label: 'LABEL_DATE_DESCENDING',
                fieldOrderBy: 'StartDateTime',
                sortDirection: Model.SortDirection.Descending
            },
            {
                label: 'LABEL_DATE_ASCENDING',
                fieldOrderBy: 'StartDateTime',
                sortDirection: Model.SortDirection.Ascending
            },
        ]; 
        public selectedSortSetting: SortSetting;

        private communicationFilters: CommunicationFilter[] = [
            {
                type: Meevo.Model.CommunicationMethodEnum.Email,
                label: 'HEADER_EMAIL',
            },
            {
                type: Meevo.Model.CommunicationMethodEnum.SMS,
                label: 'LABEL_SMS',
            },
            {
                type: Meevo.Model.CommunicationMethodEnum.Phone,
                label: 'HEADER_PHONE',
            },
            {
                type: Meevo.Model.CommunicationMethodEnum.None,
                label: 'LABEL_ALL',
            },
        ];
        private selectedCommunicationFilter = Meevo.Model.CommunicationMethodEnum.None;

        private confirmationStatusMessages = {
            155: 'LABEL_CONFIRMED',
            158: 'LABEL_UNCONFIRMED',
            157: 'LABEL_WAITING_ON_REPLY_LEFT_MESSAGE',
            1872: 'LABEL_WAITING_ON_REPLY_AWAITING_RESPONSE',
            154: 'LABEL_REPLIED_NO',
            1869: 'LABEL_QUEUED',
            1870: 'LABEL_RESCHEDULE',
            20156: 'LABEL_UNABLE_TO_CONTACT'
        }

        private statusFilters = [
            {
                type: Meevo.Model.ConfirmStateFilterEnum.Unconfirmed,
                label: 'LABEL_UNCONFIRMED'
            },
            {
                type: Meevo.Model.ConfirmStateFilterEnum.AwaitingReply,
                label: 'LABEL_WAITING_ON_REPLY'
            },
            {
                type: Meevo.Model.ConfirmStateFilterEnum.Confirmed,
                label: 'LABEL_CONFIRMED'
            },
            {
                type: Meevo.Model.ConfirmStateFilterEnum.RespondedReschedule,
                label: 'LABEL_REPLIED_NO'
            },
            {
                type: Meevo.Model.ConfirmStateFilterEnum.UnableToContact,
                label: 'LABEL_UNABLE_TO_CONTACT'
            },
            {
                type: Meevo.Model.ConfirmStateFilterEnum.All,
                label: 'LABEL_TOTAL_CLIENTS'
            },
        ];
        private selectedStatusFilter = Meevo.Model.ConfirmStateFilterEnum.All;
        private isFilterOn: boolean = false;
        private notificationSettings: Meevo.Model.NotificationSetting;

        canEditAppointmentPermission = false;
        canAddAppointmentPermission = false;
        hideClientPhoneConfirmation: boolean;
        noteTypes: any;
        appointment: any = {};

        static $inject = ["meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.common.NotificationSettingService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.plugins.appointmentBook.AppointmentNoteService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "restServer",
            '$mdDialog',
            '$filter'];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected notificationDataService: Meevo.Components.Common.NotificationSettingService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected noteService: Meevo.Plugins.AppointmentBook.AppointmentNoteService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private restServer: any,
            private $mdDialog,
            private $filter) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
            this.isMobile = device.mobile();
            this.selectedSortSetting = _(this.sortBySettings).findWhere({ label: 'LABEL_DATE_ASCENDING' })
            this.client = {};
            this.filter = {
                date: new Date(),
                clientName: ''
            };          
            this.setToday();
            this.loadNotifficationSettings();
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITAPPOINTMENT)
                .then(result => {
                    this.canEditAppointmentPermission = (result === Model.SecurityAccessEnum.Grant);
                });
            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDAPPOINTMENT)
                .then(result => {
                    this.canAddAppointmentPermission = (result === Model.SecurityAccessEnum.Grant);
                });
            this.noteService.setNoteTypes();

            $scope.$on('appointmentChanged', (event, args) => {
                var params = args.stateParams;
                if (params && params.stateName === appSettings.ROUTE_NAMES.confirmationManager && params.requireRefresh) {
                    this.displayDetails = false;    //back to main page
                    this.searchClients();           //refresh content
                }
            });

            this.hideClientPhoneConfirmation = this.$scope.$root['clientsSettings'].hideClientPhoneConfirmation;
        }

        private showModal(templateUrl, controller: any = undefined, onComplete: any = undefined, locals: any = undefined, controllerAs: string = undefined) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: templateUrl,
                controller: controller,
                controllerAs: controllerAs,
                bindToController: true,
                onComplete: onComplete,
                locals: locals
            }
            this.modalService.showCustom(options).then((result) => {
                if (result && result.callback) {
                    result.callback(result.result);
                }
                if (result && this.appointment.id === result.id
                    ) {
                    this.loadClientAppointments(this.client.id, this.clientAppointments);
                }
            });
        }

        public hideModal(result) {
            this.$mdDialog.hide(result);
        }

        showHistory() {
            if (this.client.payingClientId === undefined || this.client.payingClientId === null) {
                return;
            }

            this.showModal("app/plugins/AppointmentBook/views/AppointmentAuditLog.html", "AppointmentAuditLogController", undefined, { appointmentId: this.client.id, appointmentServiceScheduleId: undefined, appointmentRequestId: undefined });

        }

        showConfirmationHistory() {
            if (this.client.payingClientId === undefined || this.client.payingClientId === null) {
                return;
            }

            this.showModal("app/plugins/confirmationManager/sectionViews/confirmationAppointmentHistory.html", "confirmationAppointmentHistory", null, { appointmentId: this.client.id });
        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            this.context = new ConfirmationManagerContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.trackingService);
            this.context.activate(this.selectedItemId);
            this.context.deactivate = () => {
                this.visualState = Model.MaintenanceFormVisualState.Search;
            }
        }

        closeContext(): void {
            this.$rootScope.$broadcast("closeContext", this.$state.current, null);
        }

        setToday(): void {
            this.dateFilter = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            this.selectedStatusFilter = 0;
            this.clientFilter = { id: null };
            this.searchClients();
        }

        clientsToReschedule() {
            this.selectedCommunicationFilter = Meevo.Model.CommunicationMethodEnum.None;
            this.selectedStatusFilter = Meevo.Model.ConfirmStateFilterEnum.RespondedReschedule;
            this.searchClients();
        }

        updateSortBy() {
            if (!this.selectedSortSetting) return;
            this.fieldOrderBy = this.selectedSortSetting.fieldOrderBy;
            this.sortDirection = this.selectedSortSetting.sortDirection;
            this.searchClients();
        }

        searchClients(): void {
            if (this.client && this.displayDetails) {
                this.selectClient(this.client);
            };

            let that = this;

            // Initalize results collection
            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "AppointmentClientServices", (pageNumber, appointments) => {
                for (var i = 0; i < appointments.length; i++) {
                    if (appointments[i].payingClient) {
                        var pc = appointments[i].payingClient;
                        pc.showEmailIcon = pc.notificationOptions && pc.notificationOptions.length && pc.notificationOptions[0].isEmailEnabled && pc.emailAddress && pc.emailAddress.length && (pc.emailCommOptedInState == Meevo.Model.CommunicationOptedInStateEnum.OptedIn);

                        var mobilePhone = that.$filter('filter')(pc.phoneNumbers, { type: Meevo.Model.PhoneTypeEnum.Mobile, smsOptInStateEnum: Meevo.Model.CommunicationOptedInStateEnum.OptedIn })[0] || false;

                        pc.showSmsIcon = pc.notificationOptions && pc.notificationOptions.length && pc.notificationOptions[0].isSMSEnabled && mobilePhone && mobilePhone.number.length;

                        pc.showCallIcon = pc.notificationOptions && pc.notificationOptions.length && pc.notificationOptions[0].isCallEnabled && pc.phoneNumbers && pc.phoneNumbers.length;
                    }
                }
            });

            if (this.clientFilter === undefined || this.clientFilter === null) {
                this.clientFilter = { id: null };
            }

            if (this.employeeFilter === undefined || this.employeeFilter === null) {
                this.employeeFilter = { id: null };
            }

            // Prepare request
            let request = {
                pageNumber: 0,
                itemsPerPage: 25,
                sortDirection: this.sortDirection,
                criteria: {
                    fieldOrderBy: this.fieldOrderBy,
                    isCount: false,
                    payingClientId: this.clientFilter.id,
                    employeeId: this.employeeFilter.id,
                    startDateTime: this.dateFilter,
                    endDateTime: new Date(this.dateFilter.getFullYear(), this.dateFilter.getMonth(), this.dateFilter.getDate(), 23, 59, 59),
                    communicationType: 1795,
                    communicationMethod: this.selectedCommunicationFilter,
                    confirmStateFilter: this.selectedStatusFilter,
                    sortDirection: this.sortDirection
                }
            };

            this.dataService.customMethodData('/api/AppointmentBook/ConfirmStateGroupCount', "post",
                {
                    startDateTime: this.dateFilter,
                    endDateTime: new Date(this.dateFilter.getFullYear(), this.dateFilter.getMonth(), this.dateFilter.getDate(), 23, 59, 59),
                    communicationType: 1795,
                    communicationMethod: this.selectedCommunicationFilter
                }).then(response=> {
                    this.unconfirmedClientCount = this.getCount(response.data, [Meevo.Model.AppointConfirmStateEnum.Unconfirmed]);
                    this.waitingOnReplyClientCount = this.getCount(response.data, [Meevo.Model.AppointConfirmStateEnum.AwaitingResponse, Meevo.Model.AppointConfirmStateEnum.LeftMessage]);
                    this.confirmedClientCount = this.getCount(response.data, [Meevo.Model.AppointConfirmStateEnum.Confirmed]);
                    this.respondedRescheduleClientCount = this.getCount(response.data, [Meevo.Model.AppointConfirmStateEnum.RespondedReschedule]);
                    this.unableToContactCount = this.getCount(response.data, [Meevo.Model.AppointConfirmStateEnum.UnableToContact]);
                    this.allClientCount = this.getCount(response.data);
                });

            // Execute request into ties
            this.items.initSearch(request);
        }

        private getCount(groups: any, states?: Meevo.Model.AppointConfirmStateEnum[]) {
            let count = 0;
            groups.forEach(group=> {
                if (!states || states.indexOf(group.confirmState) != -1) {
                    count += group.count;
                }
            })
            return count;
        }
        getAppointmentServiceCount(filter: Meevo.Model.ConfirmStateFilterEnum) {
            
        }
        updateConfirmStatusFilter(filterType: Meevo.Model.ConfirmStateFilterEnum) {
            this.selectedStatusFilter = filterType;
            this.searchClients();
        }

        getConManHeight(): any {
            var height = angular.element('.conManInfiniteScroll').css('height');
            return height;
        }
        selectClient(client: any): void {
            this.client = client;
            this.loadClientAppointments(client.id, this.clientAppointments);
        }
        hideDetails = (): void => {
            this.displayDetails = false;
        }

        loadClientAppointments(clientId: string, clientAppointments: any): void {
            this.restServer.getAppointment(clientId, true).then(this.loadAppointment);
        }

        loadAppointment = (result) => {
            let appointment = result.data;

            this.clientAppointments = result.data.services;
            this.client.entityVersion = result.data.entityVersion;

            this.client.isMinor = result.data.payingClient.isMinor;

            this.client.payingClientId = result.data.payingClientId;
            this.client.payingClientDisplayName = result.data.payingClientDisplayName;

            this.client.guardianClientId = result.data.guardianClientId;
            this.client.guardianClientDisplayName = result.data.guardianClientDisplayName;

            if (result.data.guardianClient) {
                this.client.guardianNotificationOptions = result.data.guardianClient.notificationOptions;
            }

            let client = this.client.isMinor 
                ? result.data.guardianClient
                : result.data.payingClient;

            this.client.emailAddress = client.emailAddress;
            let phoneNumbers = client.phoneNumbers;

            for (let i = 0; i < phoneNumbers.length; i++) {
                switch (phoneNumbers[i].type) {
                    case Meevo.Model.PhoneTypeEnum.Mobile:
                        this.client.mobilePhone = phoneNumbers[i].number;
                        this.client.mobilePhoneCountryCode = phoneNumbers[i].countryCode;
                        this.client.mobilePhonePrimary = phoneNumbers[i].isPrimary;
                        break;

                    case Meevo.Model.PhoneTypeEnum.Home:
                        this.client.homePhone = phoneNumbers[i].number;
                        this.client.homePhoneCountryCode = phoneNumbers[i].countryCode;
                        this.client.homePhonePrimary = phoneNumbers[i].isPrimary;
                        break;

                    case Meevo.Model.PhoneTypeEnum.Work:
                        this.client.workPhone = phoneNumbers[i].number;
                        this.client.workPhoneCountryCode = phoneNumbers[i].countryCode;
                        this.client.workPhoneExtension = phoneNumbers[i].extension;
                        this.client.workPhonePrimary = phoneNumbers[i].isPrimary;
                        break;
                }
            }

            this.client.communicationMethod = result.data.communicationMethod;
            this.client.confirmState = result.data.confirmState;
            this.client.note = result.data.note;
            this.client.servicingClient = result.data.services[0].clientDisplayName;
            this.displayDetails = true;
            this.client.notificationOptions = result.data.payingClient.notificationOptions;
            this.appointment = appointment;
            this.loadAppointmentNote(appointment);
            return appointment;
        }

        sendToClient = (clientId): void => {
            if (!clientId) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: this.appSettings.ROUTE_NAMES.confirmationManager,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: clientId
                }
            });
        }

        private onConfirmStateChangeSuccess(client, response) {
            client.confirmState = response.confirmState;
            client.entityVersion = response.entityVersion;
            this.searchClients();
        }

        public isAppointmentUnconfirmed() {
            return this.client.confirmState === Meevo.Model.AppointConfirmStateEnum.Unconfirmed;
        }
        public isAppointmentAwaitingResponse() {
            return this.client.confirmState === Meevo.Model.AppointConfirmStateEnum.AwaitingResponse || Meevo.Model.AppointConfirmStateEnum.LeftMessage;
        }
        public isAppointmentConfirmStateAllowed() {
            return (this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.Confirmed &&
                this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.DoNotConfirm &&
                this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.Queued &&
                this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.RespondedReschedule);
        }

        public isSmsEnabled(): boolean {
            const notificationOptions = this.client.isMinor ? this.client.guardianNotificationOptions : this.client.notificationOptions;
            if (this.notificationSettings && notificationOptions) {
                let locationAppointmentConfirmationNotification = this.getAppointmentConfirmationNotificationSettings(this.notificationSettings.communicationTypeNotifications);
                let clientAppointmentConfirmationNotification = this.getAppointmentConfirmationNotificationSettings(notificationOptions);
                if (locationAppointmentConfirmationNotification && clientAppointmentConfirmationNotification) {
                    return this.notificationSettings.isSmsEnabled && this.notificationSettings.isSmsEnabledCurrentLevel
                        && locationAppointmentConfirmationNotification.isSMSEnabled
                        && clientAppointmentConfirmationNotification.isSMSEnabled;
                }
            }
            return false;
        }

        public isEmailEnabled(): boolean {
            const notificationOptions = this.client.isMinor ? this.client.guardianNotificationOptions : this.client.notificationOptions;
            if (this.notificationSettings && notificationOptions) {
                let locationAppointmentConfirmationNotification = this.getAppointmentConfirmationNotificationSettings(this.notificationSettings.communicationTypeNotifications);
                let clientAppointmentConfirmationNotification = this.getAppointmentConfirmationNotificationSettings(notificationOptions);
                if (locationAppointmentConfirmationNotification && clientAppointmentConfirmationNotification) {
                    return this.notificationSettings.isEmailEnabled && this.notificationSettings.isEmailEnabledCurrentLevel
                        && locationAppointmentConfirmationNotification.isEmailEnabled
                        && clientAppointmentConfirmationNotification.isEmailEnabled;
                }
            }
            return false;
        }

        getAppointmentConfirmationNotificationSettings(notificationSettings: any[]) {
            return _(notificationSettings).findWhere({
                communicationType: Model.CommunicationTypeEnum.AppointmentConfirmation
            });
        }

        showDisabledControls() {
            return this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.AwaitingResponse &&
                   this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.Confirmed &&
                   this.client.confirmState !== Meevo.Model.AppointConfirmStateEnum.Unconfirmed;
        }

        public sendText() {
            if (this.isAppointmentAwaitingResponse()) {
                this.modalService.confirmHandler('LABEL_SEND_TEXT_CONFIRMATION', Components.Modal.ModalTranslationModes.Translate)
                    .then(result => {
                        if (result)
                            this.sendNotification(Meevo.Model.CommunicationMethodEnum.SMS, Meevo.Model.AppointConfirmStateEnum.AwaitingResponse);
                    });
            }
            else {
                this.sendNotification(Meevo.Model.CommunicationMethodEnum.SMS, Meevo.Model.AppointConfirmStateEnum.AwaitingResponse);
            }
        }

        public sendEmail() {
            if (this.isAppointmentAwaitingResponse()) {
                this.modalService.confirmHandler('LABEL_SEND_EMAIL_CONFIRMATION', Components.Modal.ModalTranslationModes.Translate)
                    .then(result => {
                        if (result)
                            this.sendNotification(Meevo.Model.CommunicationMethodEnum.Email, Meevo.Model.AppointConfirmStateEnum.AwaitingResponse);
                    });
            }
            else {
                this.sendNotification(Meevo.Model.CommunicationMethodEnum.Email, Meevo.Model.AppointConfirmStateEnum.AwaitingResponse);
            }

        }

        private sendNotification(communicationMethod: number, confirmState: number) {
            this.restServer.sendAppointmentNotification(this.client.id, communicationMethod,
                Meevo.Model.CommunicationTypeEnum.AppointmentConfirmation, confirmState, this.client.entityVersion,
                (response) => {
                    this.onConfirmStateChangeSuccess(this.client, response)
                });
        }

        sendToNotes = (): void => {

            if (this.client.payingClientId === undefined || this.client.payingClientId === null) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: null,
                    id: this.client.payingClientId,
                    initialEditSection: "SECTION_CLIENT_NOTES",
                    clientDisplayName: this.client.servicingClient
                }
            });
        }

        sendToHistory = (): void => {


            if (this.client.payingClientId === undefined || this.client.payingClientId === null) {
                return;
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Editing,
                    id: this.client.payingClientId
                }
            });
        }

        getCurrentService() {
            return (this.client && this.client.services && this.client.services.length > 0)
                ? this.client.services[0]
                : null;
        }

        isInPast = (appointmentService) => {
            if (!appointmentService) return false;
            return (moment(appointmentService.startDateTime) < moment().startOf("day"));
        }

        canDelete = (appointmentService) => {
            appointmentService = appointmentService || this.getCurrentService();
            return appointmentService && !this.isInPast(appointmentService);
        }

        canEdit = (appointmentService) => {
            appointmentService = appointmentService || this.getCurrentService();
            return appointmentService && !this.isInPast(appointmentService);
        }

        sendToDelete = (): void => {
            if (this.client.payingClientId === undefined || this.client.payingClientId === null) {
                return;
            }

            this.client.services[0].startDateTime.setHours(0, 0, 0, 0);
            this.confirmationStatusControl.hideStatus();

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
                stateParams: {
                    actionState: Model.AppointmentBookState.DeleteAppointment,
                    actionStatePayload: {
                        id: this.client.services[0].id,
                        appointStandingDefinitionId: undefined, // TBD
                        appointmentDate: this.client.services[0].startDateTime,
                        appointmentId: this.client.id,
                        returnStateInfo: {
                            returnStateSection: this.appSettings.ROUTE_NAMES.confirmationManager,
                        }
                    }
                }
            });
        }

        sendToEditor = (): void => {
            if (this.client.payingClientId === undefined || this.client.payingClientId === null) {
                return;
            }

            this.client.services[0].startDateTime.setHours(0, 0, 0, 0);
            this.confirmationStatusControl.hideStatus();

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
                stateParams: {
                    actionState: Model.AppointmentBookState.EditAppointment,
                    actionStatePayload: {
                        finalState: this.client.services[0].finalState,
                        id: this.client.services[0].id,
                        appointStandingDefinitionId: undefined, // TBD
                        appointmentDate: this.client.services[0].startDateTime,
                        appointmentId: this.client.id,
                        returnStateInfo: {
                            returnStateSection: this.appSettings.ROUTE_NAMES.confirmationManager,
                        }
                    }
                }
            });
        }

        getEmployeeRequestType = (employeeType: number): string => {
            return <Meevo.Model.EmployeeTypeEnum>employeeType === Meevo.Model.EmployeeTypeEnum.Request
                ? "Yes"
                : "No";
        }

        toggleFilterModal = () => {
            let options: Meevo.Components.Modal.IModalOptions = {
                scope: this.$scope,
                preserveScope: true,
                templateUrl: 'app/plugins/confirmationManager/sectionViews/filterModal.template.html',
                locals: {}
            }

            this.modalService.showCustom(options).then((result) => {
                this.searchClients();
            });
        }

        closeModal = () => {
            this.modalService.hide();
            this.isFilterOn = this.checkFilterOn();
        }

        clearFilters = () => {
            this.employeeFilter = { id: null };
            this.clientFilter = { id: null };
            this.selectedCommunicationFilter = Meevo.Model.CommunicationMethodEnum.None;
            this.selectedStatusFilter = Meevo.Model.ConfirmStateFilterEnum.All;
        }

        checkFilterOn = () => {
            if (!this.employeeFilter.id && !this.clientFilter.id && this.selectedCommunicationFilter === Meevo.Model.CommunicationMethodEnum.None && this.selectedStatusFilter === Meevo.Model.ConfirmStateFilterEnum.All) {
                return false;
            }
            return true;
        }

        private loadNotifficationSettings(): void {
            this.notificationDataService
                .getSection(this.appSettings.API_ENDPOINTS.notificationSetting, "")
                .then((data: any) => {
                    this.notificationSettings = <Meevo.Model.NotificationSetting>data;
                });
        }

        loadAppointmentNote(appointment: any) {
            this.noteTypes = this.noteService.noteTypes;
            if (appointment.noteType && appointment.noteType !== 0) {
                this.appointment.noteType = _.where(this.noteTypes, { id: appointment.noteType })[0];
                this.appointment.note = appointment.note;
            } else {
                this.appointment.noteType = _.where(this.noteTypes, { id: Meevo.Model.AppointNoteTypeEnum.AppointmentBookOnly })[0];
                this.appointment.note = "";
            }
        }

        openAppointmentNote() {
            let locals =
            {
                note: this.appointment.note,
                noteType: this.appointment.noteType,
                noteTypes: this.noteTypes,
                canEdit: this.canEditAppointmentPermission || this.canAddAppointmentPermission,
                appointment: this.appointment
            };
            this.showModal("app/plugins/confirmationManager/sectionViews/appointmentNote.html", "meevo.plugins.confirmationManager.ConfirmationManagerController", undefined, locals, "vm");
        }

        saveAppointmentNote(noteText: string, noteType: any, appointment: any) {
            if (appointment.note != noteText || appointment.noteType.id != noteType.id) {
                let originalNoteText = appointment.note;
                let originalNoteType = appointment.noteType;
                appointment.noteType = (noteType != undefined && noteType.id != undefined) ? noteType.id : Meevo.Model.AppointNoteTypeEnum.AppointmentBookOnly;
                appointment.note = noteText;
                appointment.suppressWarnings = true;
                this.restServer.saveAppointHeader(appointment, (r, ed) => this.saveAppointHeaderCallback(r, ed), null, null, null,
                    () => this.saveAppointHeaderCallbackError(appointment, originalNoteText, originalNoteType));
            } else {
                this.hideModal(null);
            }
        }

        private saveAppointHeaderCallback(response, extraData) {
            this.appointment = response;
            this.hideModal(response);
        }
        private saveAppointHeaderCallbackError(appointment: any, originalNoteText: any, originalNoteType: any) {
            appointment.note = originalNoteText;
            appointment.noteType = originalNoteType;
        }
    }

    angular.module("meevo.plugins.confirmationManager")
        .controller("meevo.plugins.confirmationManager.ConfirmationManagerController", ConfirmationManagerController);
}